'use strict'
/**
 * UI Library
 */
import Sortable from 'sortablejs'
import moment from 'moment'
import { DOM } from './dom.js'
import { Transl } from './transl.js'
import { API } from './api.js'
import { util } from './util.js'
import { Template } from './template'
import { Accordion } from '../components/accordion.js'
import { Dropdown } from '../components/dropdown.js'
import { Form } from '../components/form.js'
import { Icon } from '../components/icon.js'
import { Map } from '../components/map.js'
import { Popover } from '../components/popover.js'
import { Tabs } from '../components/tabs.js'
import { Modal } from '../components/modal.js'
import { Table } from '../components/table.js'
import { Toast } from '../components/toast.js'
import { Tooltip } from '../components/tooltip.js'
import { ListGroup } from '../components/listgroup.js'
import { Upload } from '../components/upload.js'

export class UI {
    constructor(boot = null){
        window.ui = this
        this.body = this.select('body')
        this.app_api = '/'
        this.token = this.select('meta[name="csrf-token"]').getAttribute('content')
        this.lang = this.select('html').getAttribute('lang')
        this.team_id = this.body.dataset.teamId
        this.transl = new Transl()
        this.sortable = Sortable // sortablejs
        window.moment = moment
        moment.locale(this.lang)
        this.API = new API
        this.util = util
        this.DOM = DOM
        this.accordion = new Accordion
        this.dropdown = new Dropdown
        this.form = new Form
        this.listGroup = new ListGroup
        this.map = new Map
        this.modal = new Modal
        this.toast = new Toast
        this.tooltip = new Tooltip
        this.popover = new Popover
        this.table = new Table
        this.tabs = new Tabs
        this.upload = new Upload
        this.template = id => new Template(id)
        this.ready(()=>{
            // components

            this.tables = ui.select(':.table')
            this.tables.forEach((table_)=>{
                new Table(table_)
            })
            this.elementLinks(':.card.tile')
            this.customSelectDropDown()

            if(boot) this.boot(boot)
        })
        this.hashRoute = util.hashRoute



    }
    /**
     * Listen to document.readyState
     * @param {*} callback
     */
    ready(callback){
        return this.util.ready(callback)
    }
    /**
     * Boot class object; should contain boot methods and endpoint property to match with url.pathname
     * @param {*} obj
     * @param {*} methods
     */
    boot(obj){
        return this.util.boot(obj)
    }
    /**
     * Boot a group of class objects
     * @param {*} objs
     */
     bootGroup(objs){
        return this.util.bootGroup(objs)
    }

    /**
     * Find or create element with given id or tag with getElementById or createElement
     * attr can be passed as attributes object or HTMLElement to append or as boolean to guard for checking existing element
     * @param {string} tag
     * @param {object|boolean|HTMLElement} attr
     * @param {HTMLElement|string} append
     * @returns {HTMLElement}
     */
    element(tag, attr, append){
        return DOM.element(tag, attr, append)
    }
    /**
     * Check if object is HTMLElement
     * @param {*} obj
     * @returns {boolean}
     */
    isElement(obj) {
        return DOM.isElement(obj)
    }

    /**
     * Reurns element with querySelector or querySelectorAll
     * @param {*} selector
     * @returns {HTMLElement}
     */
    select(selector,parent) {
        return DOM.select(selector,parent)
    }

    fragment(contents){
        return DOM.fragment(contents)
    }
    /**
     * Return or set form field by name
     * @param {*} name
     * @param {*} value
     * @returns
     */
     field(name, value) {
        this._element = this.select(`[name="${name}"]`)
        if(value)
            this._element.value = value
        return this._element.value
    }
    /**
     * Assign property for each field by name to this.field
     * @param {*} obj
     */

    fields(obj){
        const fields = this.select(':[name]')
        fields.forEach(field => {
            const name = field.name ? field.name : field.getAttribute('name')
            obj[name] = (value) => this.field(name,value)
        })
    }
    /**
     *
     * @param {*} icon
     * @param {*} attr
     * @returns
     */
    icon(icon,attr){
        return new Icon(icon,attr)
    }
    /**
     * Element dataset query or set
     * @param {*} query
     * @param {*} value
     */
    data(query,value) {
        query = query.split('@')
        let data = query[0]
        const selector = query[1],
              element = selector ? this.select(selector) : this.select(data)
        if(HTMLCollection.prototype.isPrototypeOf(element)){
            element.forEach(el => {
                element.dataset[data] = value
            })
        }else{
            if(!element.id)
                console.warning(`UI.data : ${selector} does not contain a id`)
            data = selector ? element.dataset[data] : element.dataset
            if(value){ // set value
                if(typeof value === 'object'){
                    if(!selector){ // ui.data('#element',{key:'value'})
                        data[Object.keys(value)[0]] = value[Object.keys(value)[0]]
                    }else{ // ui.data('key@#element',{key:'value'})
                        data = JSON.stringify(value)
                    }
                }else if(typeof value === 'string'){
                    if(!selector){ // ui.data('#element','key')
                        return data[value]
                    }else{ // ui.data('key@#element','value')
                        data = value
                    }
                }

            }
        }

    }


    /**
     * Make elements clickable to containing link href in element
     * @param {*} selector
     */
     elementLinks(selector) {
        this.select(selector).forEach(element =>
            element.addEventListener('click', () =>
                window.location.assign(element.querySelector('a').getAttribute('href'))))
    }
    /**
     * Creates custom select dropdown element
     */
     customSelectDropDown(){
        const buttons = this.select(':button.select_btn'),
              contents = this.select(':.select_content')
        window.onclick = (event) => {
            if (!(event.target.matches('.select_btn')||event.target.matches('.select_content div')) ){
                if(contents)
                    contents.forEach( element =>element.classList.remove('show'))
            }else if(event.target.matches('.select_content div')){
                select(event)
            }
        }
        ['click','ontouchstart'].forEach(event => {
            buttons.forEach(element =>
                element.addEventListener(event,e=>e.target.nextElementSibling.classList.toggle('show'))
            )
        })
        function select(event) {
            const target = event.target,
                  parent = target.parentElement,
                  input = parent.parentElement.querySelector(`input`)
            input.value = target.dataset.select
            parent.parentElement.querySelector(`button`).innerHTML = target.innerHTML
            parent.classList.toggle('show')
        }
    }

    /**
     * Adds memo textarea on .add_memo click
     * @param {*} endpoint
     * @returns
     */
    addMemo(parent_){

        const add_memo = (event)=>{

            const element = event.target,
                  memo = this.element('textarea',{class:'form-control add_memo_input',name:element.getAttribute('name')+'_memo','data-type':'memo',placeholder:'Memo'}),
                  col = this.element('div',{class:'col'},memo),
                  row = this.element('div',{class:'row mb-3 memo'},col),
                  parent =  element.parentElement
           if(element.parentElement.parentElement){
            if(parent_)
                parent_.append(row)
            else
                parent.parentElement.parentElement.parentElement.insertBefore(row,parent.parentElement.parentElement.previousSibling)
            memo.addEventListener('blur',(event)=>{
                setTimeout(()=>{
                    if(event.target.value === ''){
                        row.remove()
                        parent.append(element)
                    }
                },3000)
            })
            memo.focus()
            element.remove()
           }
        }
        if(parent_){
            parent_.querySelectorAll('.add_memo').forEach(element => {
                element.removeEventListener('click',add_memo)
                element.addEventListener('click',add_memo)
            })
        }else{
            ui.select(':.add_memo').forEach(element => {
                element.removeEventListener('click',add_memo)
                element.addEventListener('click',add_memo)
            })
        }

    }
    /**
     *
     * @param {*} parent
     */
    insertMemoLink(parent){
        const add_memo_input = parent.querySelector('.add_memo_input'),
              add_memo_link = this.element('small',{class : 'float-end add_memo'},this.select('.add_memo').innerHTML)
        if(add_memo_input){
            add_memo_input.parentNode.insertBefore(add_memo_link,add_memo_input.nextSibling)
            add_memo_input.remove()
            parent.classList.remove('mb-3')
            add_memo_link.addEventListener('click',(e)=>{
                add_memo_input.value = ''
                e.target.parentNode.insertBefore(add_memo_input,add_memo_link.nextSibling)
                add_memo_input.focus()
                parent.classList.add('mb-3')
                e.target.remove()

            })
        }
    }
    /**
     *
     * @param {*} parent
     */
    iconSelect(parent){

        setTimeout(()=>{
            const select = parent ? parent.querySelectorAll(('.svg-inline--fa.input')) :  this.select(':.svg-inline--fa.input'),
                  color = {
                      default : 'blue75'
                  }


            let input
            select.forEach(item => { // input icon color on focus
                item.nextSibling.nextSibling.nextSibling.addEventListener('focus',(event) => {

                    input = event.target
                    item.parentNode.classList.add(color.default)
                })
                item.nextSibling.nextSibling.nextSibling.addEventListener('blur',(event) => {
                    input = event.target
                    item.parentNode.classList.remove(color.default)
                })
            })
        },1000)
    }
    /**
     *
     * @param {string} endpoint
     * @returns {Promise}
     */
     validateData(endpoint){
        const token = document.querySelector('[name="csrf-token"]').getAttribute('content'),
              headers = {
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                  'X-CSRF-TOKEN': token
                }
              }
        return fetch(`/api/validate/${endpoint}`,headers)
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }
    isDescendant(parent, child) {

        let node = child.parentNode;
        while (node) {
            if (node === parent) {
                return true;
            }

            // Traverse up to the parent
            node = node.parentNode;
        }

        // Go up until the root but couldn't find the `parent`
        return false;
    }

    insertAfter(newNode, existingNode) {
        existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
    }
    /**
     *
     * @param {*} element
     */
    callAction(element){
        if(!this.select('[data-endpoint]'))
            return console.error('UI.callAction : [data-endpoint] not set')
        if(!this.select('[name="csrf-token"]'))
            return console.error('UI.callAction : [name="csrf-token"] not set')
        const data = element.dataset,
              action = data.action,
              endpoint = this.select('[data-endpoint]').dataset.endpoint,
              token = this.token,
              id = element.parentNode.parentNode.parentNode.id

        let formElement, modalElement
        const form = (endpoint) => fetch(`/form/${endpoint}`),
              formData = (callback) => {
                 fetch('/api/data/'+endpoint+'/'+id).then(res => res.text()).then((data)=>callback(data))
              },
              modalInstance = (content) => {
                const modalElement = this.element('bootstrapModal'),
                      modal = new bootstrap.Modal(modalElement),
                      body = modalElement.querySelector('.modal-body'),
                      title = modalElement.querySelector('.modal-title')

                if(body.hasChildNodes())
                    body.childNodes[0].remove()
                title.textContent = endpoint+' '+action
                body.append(content)
                modal.show()
                return modal
              },
              formModal = (callback) => form(endpoint).then(res => res.text()).then(form => {

                  const parser = new DOMParser()
                  formElement = parser.parseFromString(form, 'text/html').querySelector('form')
                  modalElement = modalInstance(formElement)
                  callback(formElement)

              }),
              formPost = (event) => {
                const data = new URLSearchParams();
                for (const pair of new FormData(event.target)) {
                    data.append(pair[0], pair[1]);
                }

                fetch(url, {
                    credentials: 'same-origin', // include, *same-origin, omit
                    headers: {
                        'X-CSRF-TOKEN': token
                    },
                    method: 'post',
                    body: data,
                })
                .then((response) => {

                });
              },
              actions = {
                create(){
                    //
                },
                read(){
                    //
                },
                update(){
                    validateData(endpoint).then(res => res.text()).then((data)=> {

                        //data = JSON.parse(data)
                        formModal((form)=>{
                            formData((data)=>{

                                form.addEventListener('submit', (event)=>{
                                    event.prevenDefault()
                                    formPost(event)
                                })
                            })
                        })
                    })
                },
                delete(){
                    //
                }
              }

        if(actions[action])
            actions[action]()
        else
            console.error('UI.callAction : ' +action + ' is not a valid action (must be '+Object.keys(actions).join(', ')+')')
        switch (action) {
            case 'create':
                break;
            case 'read':
                break;
            case 'update':
                break;
            case 'delete':
                break;
            default:
                break;
        }


    }
    /**
     *
     * @param {*} callback
     * @param {*} ms
     * @returns
     */
    delay(callback, ms) {
        var timer = 0;
        return function() {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
            callback.apply(context, args);
            }, ms || 0);
        };
    }

    /**
     * Search for location address
     * @param {*} input
     */
    searchAddress(input,callback,beforeRequest, onReset = {}){
        const searchAddress = (event)=>{

            const inputElement = event.target,
                  inputElementId = inputElement.id,
                  inputElementDest = inputElement.dataset.dest,
                  inputWidth = inputElement.offsetWidth,
                  requestToken = this.token,
                  resultElement = input.parentNode.parentNode.querySelector('.results')
            let inputElementValue = inputElement.value
            resultElement.setAttribute('style',`width:${inputWidth}px !important;`)
            if(inputElementValue.length>3){
                inputElement.classList.remove('is-invalid')
                if(ui.select('.invalid-feedback'))
                    ui.select('.invalid-feedback').remove()
                if(beforeRequest)
                     inputElementValue = beforeRequest(inputElementValue)

                fetch(`/location/${inputElementDest}/${inputElementValue}`,{
                    headers: {
                    'X-CSRF-TOKEN': requestToken
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if(data.result){

                        resultElement.innerHTML = ''
                        const addresses = data.result.addresses
                        resultElement.classList.add('show')
                        if(addresses.length){
                            addresses.forEach(address => {
                                 if(address.properties.layer === 'address' || address.properties.layer === 'venue'){

                                    const addressElement = document.createElement('div'),
                                          addressParts =  address.properties.label.split(',')

                                    addressElement.textContent = address.properties.label.replace(', Netherlands','')

                                    resultElement.append(addressElement)
                                    addressElement.addEventListener('click',(event)=>{
                                        inputElement.value = address.properties.label
                                        resultElement.classList.remove('show')
                                        if(callback)
                                            callback(address)
                                    })
                                }
                            })
                            let index = -1
                            inputElement.addEventListener('keydown', (e)=>{

                                resultElement.querySelectorAll('div').forEach(div => div.classList.remove('active'))

                                if(e.key === 'ArrowDown')
                                    index++
                                if(e.key === 'ArrowUp')
                                    index--
                                if(index<0)
                                    index = resultElement.querySelectorAll('div').length-1
                                if(index>resultElement.querySelectorAll('div').length-1)
                                    index = 0
                                    resultElement.querySelectorAll('div')[index].classList.add('active')
                                if(e.key === 'Enter' && !(index < 0)){
                                    inputElement.value = addresses[index].properties.label
                                    resultElement.classList.remove('show')
                                    if(callback)
                                        callback(addresses[index])
                                }
                            })
                        }else{
                            callback(null)
                            resultElement.innerHTML = '<div class="p-12-16"><svg class="svg-inline--fa fa-circle-exclamation" aria-hidden="true" focusable="false" data-prefix="far" data-icon="circle-exclamation" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z"></path></svg> Geen resultaten voor '+inputElementValue+'</div>'
                        }
                    }else{

                    }
                })
                .catch((error) => {
                    resultElement.classList.add('show')
                    resultElement.innerHTML = '<div class="p-12-16"><svg class="svg-inline--fa fa-triangle-exclamation" aria-hidden="true" focusable="false" data-prefix="far" data-icon="triangle-exclamation" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M506.3 417l-213.3-364C284.8 39 270.4 32 256 32C241.6 32 227.2 39 218.1 53l-213.2 364C-10.59 444.9 9.851 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM52.58 432L255.1 84.8L459.4 432H52.58zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44c0 17.36 14.11 31.44 31.48 31.44s31.4-14.08 31.4-31.44C287.4 351.2 273.4 337.1 256 337.1zM232 184v96C232 293.3 242.8 304 256 304s24-10.75 24-24v-96C280 170.8 269.3 160 256 160S232 170.8 232 184z"></path></svg> Er is een fout opgetreden</div>'
                    console.error('Error:', error)
                });
            }else{
                resultElement.classList.remove('show')
            }
        }
        input.addEventListener('input', (event) => {
			this.delay(searchAddress,250)(event)
			if(input.value.length <= 1){
				if(onReset){
						onReset();
				}
			}
		})
        input.addEventListener('blur',this.delay((event)=>{
            input.parentElement.parentElement.querySelector('.results').classList.remove('show')
        },250))

    }
    /**
     *
     * @param {*} input
     */
    searchRelation(input = ui.element('search_relation').querySelector('input'),callback){
        const searchRelation = (event) => {
            const inputElement = event.target,
                  inputWidth = inputElement.offsetWidth,
                  searchValue = inputElement.value,
                  resultElement = input.parentNode.querySelector('.results'),
                  requestToken = this.token,
                  parseResult = (relation) => {
                    inputElement.value = `${relation.firstName} ${relation.lastName}`
                    resultElement.classList.remove('show')
                    this.element('relation_name').value = `${relation.firstName} ${relation.lastName}`
                    if (relation.email)
                        this.element('relation_email').value = relation.email
                    if (relation.phones.length)
                        //this.element('relation_phone').value = relation.phones.filter(phone => phone.preferred)[0]
                        this.element('relation_phone').value = relation.phones[0].number
                  }
            resultElement.setAttribute('style',`width:${inputWidth}px !important;`)
            if(searchValue.length>3){

                fetch(`/relation/search/${searchValue}`,{
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-CSRF-TOKEN': requestToken
                    },
                    credentials: 'same-origin'
                })
                .then(response => response.json())
                .then(relations => {
                    if(relations.length){
                        resultElement.innerHTML = ''
                        resultElement.classList.add('show')
                        relations.forEach(relation => {
                            const relationElement = this.element('div',{class:'search-relation-result'})
                            relationElement.innerHTML = `<span class="lead"><i class="fa-solid fa-address-book"></i> ${relation.firstName} ${relation.lastName}</span>${relation.email ? ' | <i class="fa-light fa-envelope"></i> ' + relation.email: ''}${relation.phone ? ` | <i class="fa-light fa-phone"></i> ${relation.phone}`: ''}`
                            resultElement.append(relationElement)
                            relationElement.addEventListener('click',(event)=>{
                                parseResult(relation)
                                if(callback)
                                    callback(relation)
                            })
                        })
                    }
                })
                .catch(error => {
                    console.error(error);
                })
            }else{
                resultElement.classList.remove('show')
            }

        }
        input.addEventListener('input',this.delay(searchRelation,250))
        input.addEventListener('blur',this.delay((event)=>{
            input.parentElement.parentElement.querySelector('.results').classList.remove('show')
        },250))


    }
    /**
     * @see https://leafletjs.com/reference.html
     */
    getMap(options = {}, callback){
        const map = this.element('map')
        let status
        if(map){
            map.classList.remove('hide') // show map
            const addresses = new Array(),
                  destinations = new Array(),
                  requestToken = this.token
            this.select(':.address_data').forEach(element=>{
                if(element.value){

                    const data = JSON.parse(element.value)
                    addresses.push({
                        lat : data.geometry.coordinates[1], lng : data.geometry.coordinates[0],
                        label : /*element.parentElement.parentElement.parentElement.querySelector('[type="time"]').value + ' ' + */data.properties.label})
                    destinations.push([data.geometry.coordinates[1],data.geometry.coordinates[0]])
                }
            })
            if(addresses.length > 1){
                options.vehicleType =  options.vehicleType ? options.vehicleType : 'CAR'
                options.destinations = destinations
                fetch('/location/route',{
                    method : 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-CSRF-TOKEN': requestToken,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(options),
                    credentials: 'same-origin'

                })
                .then(response => {
                    status = response.status
                    return response.json()
                })
                .then((response)=>{

                    if(status === 200){
                        this.map.get({
                            attribution : '',
                            zoom : 18,
                            addresses : addresses,
                            route : response.route
                        })
                        map.dataset.response = JSON.stringify(response)
                        if(callback){
                            return callback(response)
                        }
                    }else{
                        const adresses = new Array()
                        ui.select(':[data-type="label"]').forEach(address => {
                            if(adresses.includes(address.value)){
                                const error_msg = ui.element('div',{class : 'row'},
                                    ui.element('div',{class : 'col'},
                                        ui.element('div',{class : 'msg invalid-feedback',style : 'display:unset;'},'<b>Error :</b> Arrival address can not be the same as address of departure')
                                    )
                                )
                                address.classList.add('is-invalid')
                                address.focus()
                                this.insertAfter(error_msg,address.parentElement.parentElement.parentElement)
                            }
                            adresses.push(address.value)
                        })
                        this.map.element.classList.add('hide')
                        ui.toast.show({
                            type : 'error',
                            message : response.message,
                            remove : 6000
                        })
                    }



                })

             }else{
                 if(addresses.length){
                    this.map.get({
                        attribution : '',
                        zoom : 18,
                        addresses : addresses,
                    })
                 }

             }

        }
    }
    getRoute(){

    }
   /**
    *
    * @param {*} message
    * @param {*} type
    * @param {*} remove
    */
    notify(message,type = 'info',remove = 5000){
        this.toast({ type : type, message : message, remove : remove })
        switch(type){
            case 'error':
                console.error(message)
                break;
            case 'warning':
                console.warn(message)
                break;
            case 'success':
            default:
                console.log(message)
                break;
        }

    }

}
